import isEqual from 'lodash/isEqual';
import mergeWith from 'lodash/mergeWith';
import { QueryParamsDictionary, Updater } from './model';

const cleanup = (dest: Partial<QueryParamsDictionary>, src: Partial<QueryParamsDictionary>) => {
  for (const key in src) {
    if ([undefined, null, ''].includes(src[key])) {
      delete dest[key];
    } else if (dest[key] && typeof dest[key] === 'object' && typeof src[key] === 'object') {
      cleanup(dest[key], src[key]);
    }
  }
  return dest;
};

export const patchParams: Updater = (queryParams, update) => {
  const isChanged = -1 !== Object.entries(update).findIndex((entry) => !isEqual(queryParams[entry[0]], entry[1]));
  if (!isChanged) {
    return queryParams;
  }
  const nextParams = mergeWith(Object.assign({}, queryParams), update, (_, sourceValue) => {
    if (Array.isArray(sourceValue)) {
      return sourceValue;
    }
  });
  return cleanup(nextParams, update);
};
